<template>
  <section class="pl-foot pl-spacer pl-spacer--out--small pl-spacer--cut-h">
    <div :class="{ 'container': !cookieDivOr, 'container-collapsed': cookieDivOr}">
      <!-- /* TODO pl-foot__top, implement breadcrumbs */ -->
      <!--
      <div class="col-xs-12 pl-foot__top">
        <ul class="pl-list pl-list--inline pl-list--inline--dividers pl-color pl-color--gray">
          <li>
            <a href="/">
              <CanonLogo />
              <span class="pl-visually-hidden">Canon</span>
            </a>
          </li>
          <li itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">
            <span itemprop="name">Business Products, Solutions &amp; Services</span>
          </li>
        </ul>
      </div>
      -->

      <div id="footer-consumer"
           class="dual-footer"
           data-footer-business="/businessfooter.html">
          <div class="col-xs-12 pl-foot__copyright">
            <div class="row">
              <div style="width:98%;"
                   class="flex_colum col-xs-12 col-lg-4 text-center--mobile text-center--tablet text-right--desktop">
                  <div class="col-lg-5"
                       style="box-sizing:border-box">
                    <ul class=" pl-foot__social pl-foot__list pl-foot__list--center pl-color pl-color--gray sina">
                      <li class=" pl-foot__list-item pl-foot_social-icons">
                        <!-- <a href="https://www.youtube.com/user/CanonEurope" target="_blank">
                      <i class="icon-youtube"></i> <span
                        class="pl-visually-hidden">youtube</span>
                    </a> -->
                        <a style="position:relative">
                          <span>
                            <img src="@/assets/FFP/images/wx.png"
                                 alt="">
                          </span>官方微信公众号
                          <img class="wxQRCode"
                               src="@/assets/FFP/images/QRCode.png"
                               alt="">
                        </a>
                      </li>

                      <li class="pl-foot__list-item pl-foot_social-icons">
                        <!-- <a href="https://www.linkedin.com/company/canon-emea/" target="_blank">
                      <i class="icon-linkedin"></i> <span
                        class="pl-visually-hidden">linkedin</span>
                    </a> -->
                        <a href="https://www.weibo.com/u/7287543648"
                           style="position:relative">
                          <span>
                            <img src="@/assets/FFP/images/wb.png"
                                 alt="">
                          </span>官方新浪微博
                          <!-- <img class="wxQRCode"
                               src="@/assets/FFP/images/QRCode.png"
                               alt=""> -->
                        </a>
                      </li>
                    </ul>
                  </div>
                <div class="text_align_center pl-color pl-color--gray floatLeft icp" style="text-align:center;">
                  <p>佳能商务科技(广东)有限公司版权所有，未经许可不得转载</p>
                  <p><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026055571号</a>
                  <img src="@/assets/FFP/images/gongan.png"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402004172"> 粤公网安备44030402004172号</a></p>
                </div>
                <div class="col-lg-7 floatRight font_size_15"
                     style="box-sizing:border-box;z-index:3">
                  <div class=" pl-foot__legal pl-foot__list pl-foot__list--center pl-color pl-color--gray">
                    <p class="pl-foot__list-item_link "><a href="https://global.canon/"
                         target="_self">
                        佳能全球
                      </a>
                      <span class="hidden footeren">Contact Us</span>
                      <span class="hidden footeren">Contact Us</span>
                    </p>
                    <p class="pl-foot__list-item_link "><a
                         href="../terms-of-use"
                         target="_blank">
                        使用条款
                      </a>
                      <span class="hidden footeren">About Us</span>
                      <span class="hidden footeren">About Us</span>
                    </p>
                    <p class="pl-foot__list-item_link"><a
                         href="../privacy-policy"
                         target="_blank">
                        隐私政策
                      </a>
                      <span class="hidden footeren">Press Centre</span>
                      <span class="hidden footeren">Press Centre</span>
                    </p>
                  </div>
                  <p class="pl-color--gray"
                     style="text-align:center; margin-top:5px">客服电话：(86) 400 930 8278</p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="pl-generic-popup">
      <div class="footer-bgimg floatLeft">
        <img alt="corner"
             src="../assets/FFP/images/corner.png" />
      </div>
    </div>
    <div class="dialog"
         v-if="legalStatement">
      <p class="dialog_title text_center">使用条款</p>
      <p><span class="underline"> 请您在使用本网站前仔细阅读本使用条款，该使用条款中包含您作为本网站用户所享有的权利和义务等重要内容。当您有浏览、进入及使用本网站（如复制任何信息、注册成为网站用户等）之行为时，即表示您已同意接受本使用条款的全部内容，</span>从而成为您与佳能商务科技（广东）有限公司（以下简称“佳能商务科技（广东）”）就使用本网站所做的双方合意约定。若您不同意，请停止使用本网站。</p>
      <p class="dialog_subtitle font_weight_600">服务说明：</p>
      <p>本网站仅为用户提供网络服务。您需要自行配备上网的所需设备（如个人电脑、手机、或其他必备上网装置）及所需费用（如上网所支付的与此服务有关的电话费用、 网络费用、手机费用等）。 基于佳能商务科技（广东）所提供的服务的重要性，您同意：</p>
      <p>（1）提供详尽、准确的个人资料。不断更新注册资料，符合及时、详尽、准确的要求；</p>
      <p>（2）对您在本网站发表的任何内容的真实性、合法性、有效性承担全部责任；</p>
      <p>（3）遵守所有适用的法律法规，若您在使用本网站时违反任何规定，佳能商务科技（广东）可自行判断要求您改正或采取一切必要的措施以减轻您的不当行为造成的影响。</p>
      <p class="dialog_subtitle font_weight_600">用户名、用户密码和安全性</p>
      <p>本网站可能会邀请您就本网站或本网站某项服务的使用进行身份注册，佳能商务科技（广东）完全尊重您自主决定是否进行身份注册。如果您选择进行身份注册，请您遵守本网站指示的其他条款和条件，包括但不限于注册条款。</p>
      <p>您一旦注册成功并获得佳能商务科技（广东）分配的用户名和密码，应妥善保管该用户名和密码，不得将其转让或授予他人使用，并对以其用户名从事的一切活动承担责任。</p>
      <p> 如因保管疏忽、黑客攻击等原因导致用户名和密码遭他人非法使用的，佳能商务科技（广东）恕不承担责任，敬请谅解。若您发现您的用户名和密码遭他人非法使用，应立即通知佳能商务科技（广东）。</p>
      <p>佳能商务科技（广东）同时保留无需任何理由随时终止您访问本网站的权利（包括收回其注册身份）。</p>
      <p class="dialog_subtitle font_weight_600">隐私政策</p>
      <p>保护用户个人信息是佳能商务科技（广东）的一项基本原则。佳能商务科技（广东）将按照本协议及《隐私政策》（链接地址：http://www.canon-bsg.com.cn/privacy_policy）的规定收集、使用、转让和共享您的个人信息。本协议对个人信息保护规定的内容与上述《隐私政策》有冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。</p>
      <p class="dialog_subtitle font_weight_600">特别项目、功能和活动</p>
      <p>本网站可能会提供某些特别项目、功能和活动（比如竞赛、抽奖或其他活动），除遵守本使用条款外，这些活动会(1)适用另行制定的使用规则、条款和/或政策；并(2) 由佳能商务科技（广东）或授权第三方提供。若您选择参与这些活动，即视为您同意参与活动适用另行制定的使用规则、条款和/或政策。</p>
      <p class="dialog_subtitle font_weight_600">网站服务内容的知识产权：</p>
      <p>本网站所有内容（包括但不限于文字、说明、图画、图片、图形、档案、页面设计、网站规划与安排等）之著作权及其他知识产权皆为佳能商务科技（广东）或其相关权利人所有。您不得以任何方式修改或者复制或者公开展示、公布或分发这些材料或者以其它方式把它们公开或用于商业目的。任何人未经书面授权，不得就本网站之内容享有任何权利。您不得对本网站内容之全部或部分进行下列行为，包括但不限于复制、储存、下载、使用、修改、改作、链接、公开播送、公开播映、传送、进行还原工程、解编或反向组译，如若有佳能商务科技（广东）或相关权利人事先书面许可，或本网站有其它授权及允许规定时，不在此限。</p>
      <p class="dialog_subtitle font_weight_600">商标权之保护：</p>
      <p>您对佳能或佳能关联企业拥有的商标、商号、标识、图案、佳能产品型号及名称、本网站的名称、域名或其衍生物（以下简称“佳能标识”）不拥有任何权利。本使用条款亦不授予您上述任何权利或权益。</p>
      <p>本网站提及的其它产品或公司之名称，有可能是其它人之商标或企业表征。您不因进入及使用本网站即表示经明示或默示而有权使用出现在本网站的商标，除非您获得本公司或各该权利人之事先书面许可。</p>
      <p class="dialog_subtitle font_weight_600">软件的使用：</p>
      <p>如果您从本网站下载软件，使用软件要遵守随该软件携带的许可协议中的许可条款。在您阅读并且接受软件许可协议的各项条款之前建议不要下载或安装这一软件。</p>
      <p class="dialog_subtitle font_weight_600">链接第三方Web网站：</p>
      <p>本网站链接到第三方Web网站的链接仅作为一种方便服务提供给您，您可由本网站链接至第三人拥有或经营的网站。在链接并使用第三方网站时，请您先行阅读并决定是否同意该第三方网站之使用规定。由于佳能商务科技（广东）未审核过也无法完全审查所有相关第三方之网站，对任何这些网站及其内容不进行控制，也恕不承担责任，敬请谅解。因此，佳能商务科技（广东）对这些网站上的任何信息、软件及其它产品服务或材料，或者通过使用它们可能获得的任何结果不予认同亦未作任何陈述。如果您决定访问本站链接的任何第三方网站，其风险需要由您承担。您若认为第三方网站不适合您的需求，或不信任其内容，请您尽速离开该等网站。您在第三方网站上所进行之任何行为，包括但不限于买卖、赠与、抽奖、接受服务等，均与本公司无关，本公司亦声明绝不介入任何您与第三方网站间之任何行为，您在其他网站所为之行为若产生争议，请向该行为之相对人或服务提供者请求。</p>
      <p class="dialog_subtitle font_weight_600">责任声明</p>
      <p>您同意对使用佳能商务科技（广东）网络服务的行为和后果承担全部责任与风险，因您不当使用佳能商务科技（广东）网络服务、违反本条款或在您的账户名义下采取的一切行动，而导致的任何第三方索赔，需要由您本人承担。如果由此引起佳能商务科技（广东）及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并承担由此造成的全部责任。</p>
      <p>本网站所载内容仅为便利您使用及了解佳能商务科技（广东）而设置。佳能商务科技（广东）将以现有及实时的网页内容供您个人非商业用途使用。在法律允许的范围内，佳能商务科技（广东）对由于使用本网站有关的任何间接的、偶然的或其他形式的损失（包括但不限于商业利润损失、业务中断或商业信息丢失）不承担责任，敬请谅解。</p>
      <p>佳能商务科技（广东）不担保网络服务一定能满足您的要求，也不担保网络服务不会中断，对服务的及时性、安全性、准确性都不作担保。 对于因不可抗力或佳能商务科技（广东）不能避免或控制的原因造成的网络服务中断或其它缺陷，佳能商务科技（广东）恕不承担责任，但将尽力减少因此而给您造成的损失和影响。</p>
      <p class="dialog_subtitle font_weight_600">注意事项</p>
      <p class="underline">本网站包含一部分广告/市场推广等内容，敬请知悉。</p>
      <p class="underline">本网站将尽可能地提供准确的信息。本网站内所涉及的产品图片与实物可能有细微区别，效果演示图和示意图仅供参考，有关佳能产品的外观（包括但不限于颜色）请以实物为准。限于篇幅，本网站中所包含的信息（包括但不限于产品规格、功能说明等）可能不完整，请以有关产品使用说明书的具体信息为准。</p>
      <p class="underline">本网站中产品介绍、技术规格等有关产品和服务的说明，是对佳能经营的产品和提供的服务进行的说明，仅限于佳能集团、佳能产品和服务的范围内，不存在与其他公司、其他产品和服务比较的情况。</p>
      <p class="underline">本网站可能展示由第三方制造商/供应商 (「第三方」) 制造及/或提供予佳能商务科技（广东）的产品/服务。相关产品受第三方提供、发布及授予的条款约束。除非本协议另有规定，并在适用法律允许的最大范围内，您在此同意有关第三方提供之任何保养是对相关产品任何故障、缺陷或失效的唯一保养，任何及所有与相关保养的申索仅与第三方（而非佳能商务科技（广东））相关。</p>
      <p class="dialog_subtitle font_weight_600">服务的变更、中断或终止</p>
      <p>鉴于网络服务的特殊性，佳能商务科技（广东）有权随时变更或中断或终止部分或全部网络服务，恕不对您或第三方负责。</p>
      <p>如发生下列任何一种情形，佳能商务科技（广东）有权随时中断或终止向您提供网络服务而恕不对您或任何第三方承担责任：</p>
      <p>（1）您提供的资料不真实；</p>
      <p>（2）您发布的信息违反法律法规或侵犯第三人的合法权利；</p>
      <p>（3）您违反本条款的有关规定；</p>
      <p>（4）按照主管部门的要求；</p>
      <p>（5）您利用本网站服务实施违法行为或有违良好道德风尚或公序良俗的行为或活动。</p>
      <p class="dialog_subtitle font_weight_600">服务条款的变更和修订</p>
      <p>佳能商务科技（广东）有限公司有权随时修改本协议之任一条款，并有权以消息推送、网页公告等方式予以公布，而无需另行单独通知您，您需要经常访问该页面以及时了解当前的条款，这些条款的某些条文也可能被位于本站中的某些页面明确指定的法律通告或条款所取代。若您在本使用协议条款内容公告变更后继续使用本网站服务，则表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的条款内容使用本网站服务；若您不同意修改后的服务条款，请您立即停止使用本网站服务。</p>
      <p class="dialog_subtitle font_weight_600">法律适用与管辖</p>
      <p>本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</p>
      <p>如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，<span class="underline"> 任何一方均可向位于深圳市的深圳国际仲裁院（深圳仲裁委员会），依其当时有效的仲裁规则申请仲裁。仲裁裁决是终局的，对双方均具有约束力。</span></p>
      <input type="button"
             @click="legalStatement=false"
             value="确认" />
    </div>
    <div class="dialog"
         v-if="privacyPolicy">
      <p class="dialog_title text_center">隐私政策</p>
      <p class="dialog_subtitle text_center font_weight_600">提示条款</p>
      <p>佳能商务科技（广东）有限公司（以下简称“佳能商务科技（广东）” 或“我们”）非常重视用户的隐私和个人信息保护。<span class="underline">您在使用我们的相关服务时，我们可能会收集和使用您的相关信息。</span>我们希望通过本《隐私政策》（以下简称“本政策”）向您说明，在使用我们的服务时，我们如何收集、使用、转让和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。</p>
      <p><span class="underline">本政策与您所使用的服务息息相关，希望您仔细阅读并透彻理解本政策，在需要时，按照本政策的指引，作出您认为适当的选择。</span>本政策中涉及的相关技术词汇，我们尽量简明扼要的表述，以便您的理解。<span class="underline"> 一旦您使用我们的服务，即意味着您已充分理解并同意我们按照本政策收集、使用、转让和分享您的相关信息。当我们更新本政策时，您继续使用我们的服务，即意味着您已充分理解并同意本政策的更新。</span></p>
      <p class="dialog_subtitle text_center font_weight_600">隐私政策条款</p>
      <p class="font_weight_600">本政策将帮助您了解以下内容：</p>
      <p>1、我们如何收集和使用您的个人信息</p>
      <p>2、我们如何使用 Cookie 和同类技术</p>
      <p>3、我们如何共享、转让、公开披露您的个人信息</p>
      <p>4、我们如何保护您的个人信息</p>
      <p>5、您的权利</p>
      <p>6、我们如何处理未成年人的个人信息</p>
      <p>7、您的个人信息如何在全球范围转移</p>
      <p>8、本政策如何更新</p>
      <p>9、如何联系我们</p>
      <p class="dialog_subtitle font_weight_600">一、我们如何收集和使用您的个人信息</p>
      <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<span class="underline">包括但不限于：基于以下目的，由您提供或我们获取的您的姓名、年龄、性别、出生日期、身份证号/护照号、电话（包括手机）、微信、QQ等社交媒体账号、电子邮箱、银行账户等信息。</span></p>
      <p class="dialog_subtitle font_weight_600">（一）我们仅会出于以下目的，收集和使用您的个人信息：</p>
      <p class="underline">1、用于向您提供佳能产品或者服务相关的用户注册、产品注册等服务；</p>
      <p class="underline">2、用于向您提供佳能产品或者服务的促销活动以及您报名参加的各类活动的宣传、推广、运营、活动反馈调查等相关事宜；</p>
      <p class="underline">3、用于向您交付促销品、奖品等产品或服务；</p>
      <p class="underline">4、用于向您提供与佳能产品或者服务相关的信息（包括但不限于佳能产品的宣传资料、调查问卷以及促销活动信息），展示、推送您感兴趣的产品或服务信息；</p>
      <p class="underline">5、用于开展内部审计、佳能产品或者服务的用户需求调研等数据分析和研究，改善我们的产品或服务；</p>
      <p class="underline">6、用于保证您使用我们的产品或服务是的安全性，保护您、其他用户或公众的人身财产安全，维护网络安全或排除网络故障，依法采取必要的记录、审计、分析或处置措施。</p>
      <p class="dialog_subtitle font_weight_600 font_weight_600">（二）其他用途</p>
      <p>当我们要将您的信息用于本政策未载明的其他用途时，会事先征得您的同意。</p>
      <p class="dialog_subtitle font_weight_600 font_weight_600">（三）征得授权同意的例外</p>
      <p class="underline">根据相关法律法规的规定，以下情形中我们收集和使用您的个人信息无需征得您的授权同意：</p>
      <p>1、与国家安全、国防安全有关的；</p>
      <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
      <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p>4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>5、所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
      <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>7、根据个人信息主体要求签订和履行合同所必需的；</p>
      <p>8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
      <p>9、为合法的新闻报道所必需的；</p>
      <p>10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
      <p>11、法律法规规定的其他情形。</p>
      <p class="dialog_subtitle font_weight_600">二、我们如何使用 Cookie和同类技术</p>
      <p class=" font_weight_600">（一）Cookie</p>
      <p>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好等数据。</p>
      <p>我们不会将Cookie用于本政策所述目的之外的任何目的。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</p>
      <p class=" font_weight_600">（二）其他同类技术</p>
      <p>除 Cookie 外，我们还会在网站上使用网站信标、像素标签等其他同类技术，帮助我们了解您的产品或服务偏好并改善客户服务。</p>
      <p class="dialog_subtitle font_weight_600">三、我们如何共享、转让、公开披露您的个人信息</p>
      <p class=" font_weight_600">（一）共享</p>
      <p>我们不会与佳能商务科技（广东）及本网站服务提供者以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
      <p>1、<span class="underline">在获取明确同意的情况下共享</span>：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
      <p>2、<span class="underline">我们可能会根据法律法规规定、诉讼争议需要、或按行政、司法机关依法提出的要求，</span>对外共享您的个人信息。</p>
      <p>3、<span class="underline">与我们的关联公司共享</span>：您的个人信息可能会与佳能商务科技（广东）的关联公司共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束。佳能商务科技（广东）的 关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
      <p>4、<span class="underline">与授权合作伙伴共享</span>：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户 服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个 人信息用于任何其他用途。</p>
      <p>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
      <p class=" font_weight_600">（二）转让</p>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</p>
      <p>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
      <p class=" font_weight_600">（三）公开披露</p>
      <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
      <p>1、获得您明确同意后；</p>
      <p>2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
      <p class=" font_weight_600">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
      <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
      <p>1、与国家安全、国防安全直接相关的；</p>
      <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>5、个人信息主体自行向社会公众公开的个人信息；</p>
      <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
      <p class="dialog_subtitle font_weight_600">四、我们如何保护您的个人信息</p>
      <p>（一）我们会采用符合业界标准、合理可行的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</p>
      <p>（二）我们会采取合理可行的措施，尽量避免收集无关的个人信息，保护您的个人信息。</p>
      <p>（三）我们会在必要合理的期限内保留您的个人信息。</p>
      <p>（四）互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，妥善保护自己的个人信息，仅在必要的情形下谨慎发送、共享个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
      <p>请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息。</p>
      <p>请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>
      <p class="dialog_subtitle font_weight_600">五、您的权利</p>
      <p>（一）按照中国相关的法律、法规、标准，我们保障您对自己的个人信息行使以下权利：</p>
      <p>您有权更正、删除您提供的个人信息，改变您授权同意的范围，或者注销账户，法律法规规定的例外情况除外。如果您想行使上述权利，您可以按照我们具体收集个人信息相关页面提示的方式操作。</p>
      <p>除此之外，您也可以<a href="mailto:enquiry@cbsg.canon.com.cn">点击此处</a>与我们联系。</p>
      <p>（二）响应您的上述请求</p>
      <p class="underline">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
      <p>对于您合理的请求，我们原则上不收取费用，<span class="underline">但 对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span></p>
      <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
      <p>1、与国家安全、国防安全有关的；</p>
      <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
      <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p>4、有充分证据表明您存在主观恶意或滥用权利的；</p>
      <p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
      <p>6、涉及商业秘密的。</p>
      <p class="dialog_subtitle font_weight_600">六、我们如何处理未成年人的个人信息</p>
      <p>（一）我们非常重视未成年人个人信息的保护。我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未满18周岁的未成年人不得创建自己的用户账户。</p>
      <p>（二）对于经父母同意而收集的未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>
      <p class="dialog_subtitle font_weight_600">七、您的个人信息如何在全球范围转移</p>
      <p>（一）原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内，以下情形除外：</p>
      <p>1）法律法规有明确规定；</p>
      <p>2）获得您的明确授权。</p>
      <p>针对以上情形，我们会根据本政策对您的个人信息提供足够的保护。</p>
      <p>（二）由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。</p>
      <p class="dialog_subtitle font_weight_600">八、本政策如何更新</p>
      <p>为给您提供更好的服务以及随着我们业务的发展，<span class="underline">本政策也会随之适时变更</span>。但未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会通过在本网站上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问本网站及时了解最新的隐私政策。</p>
      <p class="dialog_subtitle font_weight_600">九、如何联系我们</p>
      <p>如果您对本政策有任何疑问、意见或建议，请<a href="mailto:enquiry@cbsg.canon.com.cn">点击此处</a>与我们联系。</p>
      <input type="button"
             @click="privacyPolicy=false"
             value="确认" />
    </div>
    <div class="cookieDiv" v-if="cookieDivOr">
      <span>如阁下继续浏览本网站，即表示同意并接受有关<a href="../terms-of-use" target="_blank">使用条款</a>及<a href="../privacy-policy" target="_blank">隐私政策</a>（包括同意本网站使用Cookies为阁下提供更佳的浏览体验）。</span>
      <div class="aDiv">
        <a style="margin-left:2.16em;" @click="closeDiv">按此关闭</a>
      </div>
    </div>
  </section>
</template>

<script>
import CanonLogo from './CanonLogo.vue'
import contents from '../json/contents.json'

export default {
  name: 'Footer',

  components: {
    CanonLogo
  },

  data () {
    return {
      content: '',
      legalStatement: false,
      privacyPolicy: false,
      cookieDivOr: true
    }
  },

  methods: {
    getImagePath (name) {
      var images = require.context('../assets/FFP/images/', true, /\.png$/)
      return name ? images(name) : ''
    },
    getCookie: function (cname) {
      var name = cname + '='
      console.log(name)
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        console.log(c)
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    setCookie: function (cname, cvalue) {
      console.log('setCookie')
      document.cookie = cname + '=' + cvalue + '; '
    },
    clearCookie: function () {
      this.setCookie('', '')
    },
    checkCookie: function () {
      var user = this.getCookie('isAcceptCookie')
      if (user !== '') {
        console.log('111')
        this.cookieDivOr = false
      } else {
        console.log('111')
        this.cookieDivOr = true
      }
    },
    closeDiv () {
      this.setCookie('isAcceptCookie', '1')
      this.cookieDivOr = false
    }
  },

  mounted () {
    this.content = contents.footer
  },

  created () {
    this.checkCookie()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='../assets/FFP/css/Footer.css'></style>



// WEBPACK FOOTER //
// src/components/Footer.vue